import { BehaviorParameters } from 'rangeConfig/@types';
import { ErrorMessages, NightLightsSystem, ProductType } from '@inter-ikea-storageone/range';
import { ComponentIds, Entity } from '@inter-ikea-core/core';
import { getClosestConnectorWithKey } from 'rangeConfig/shared/utils/connectors';
import { hideNoFramesInSceneErrorMessage } from 'rangeConfig/shared/rules/hideMenuRules';

const addLightsDrop = ({
  coreApi,
  props,
  rootState: {
    layout: { darkScene }
  }
}: BehaviorParameters) => {
  const productId = props.coreProductIds?.length ? props.coreProductIds[0] : props.coreProductId;
  const targetConnector = getClosestConnectorWithKey(coreApi, 'inner-light', props.position);

  if (!targetConnector) return;

  const target = coreApi.entities.getAssemblyRoot(targetConnector.host) ?? targetConnector.host;

  if (!target) {
    // Add anyway to trigger error message
    coreApi.products.add(productId);

    const placementAttemptErrorMessage = !hideNoFramesInSceneErrorMessage(coreApi)
      ? ErrorMessages.NoFramesInScene
      : ErrorMessages.NoRoomForOuterLights;
    coreApi.emit.onPlacementAttempt(placementAttemptErrorMessage);
    return;
  }
  if (!targetConnector) return;

  const oldLights = coreApi.entities.getDescendantsWithComponent(
    target,
    ComponentIds.LIGHT_COMPONENT_ID
  );

  const noShelfParent = (entity: Entity) => {
    const parent = coreApi.entities.getParent(entity);
    return parent && !coreApi.entities.isProductType(parent, ProductType.BESTA_SHELF);
  };

  // Do not replace lights on shelves if dropped on frame
  const targetLights = target.hasComponent(ComponentIds.FRAME_COMPONENT_ID)
    ? oldLights.filter(noShelfParent)
    : oldLights;

  targetLights.forEach(l => coreApi.products.replace(l.id, productId));
  coreApi.products.addToTarget(productId, target);
  if (!darkScene) {
    const currentLightsInScene = coreApi.entities.getByComponent(ComponentIds.LIGHT_COMPONENT_ID);
    if (currentLightsInScene.length > 0) {
      coreApi.getSystem<NightLightsSystem>('NightLightsSystem')?.enable();
      coreApi.emit.onEnableNightMode(true);
    }
  }
};

export default addLightsDrop;
